import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { resolvePath } from "@utils/resolvePath";

export const ViewGaragesWrapper = styled.div`
  background-image: url(${resolvePath("/images/view_garages.png")});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 32px 16px;
  border-radius: 16px;
  background: linear-gradient(270deg, rgba(0, 0, 0, 0.00) 0.92%, rgba(0, 0, 0, 0.50) 45.36%), url(${resolvePath("/images/view_garages.png")}) lightgray 50% / cover no-repeat;
  min-width: 100%;
  box-sizing: border-box;

`;

export const ViewGaragesButton = styled.div`
  display: flex;
  padding: 8px 16px;
  margin-top: 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #fff;
  color: var(--Text-Primary, #040222);
  text-align: center;
  cursor: pointer;
  max-width:60%;
  width:110px;

  /* Label/X Small */
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
`;

export const BannerText = styled(Text)`
    color: #FFF;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    @media (min-width: 768px) {
      font-size: 16px;
    }
`;

export const AuthorisedGarages = styled(Text)`
  color: var(--Text-White, #fff);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  display: none;
  margin-bottom: 8px;
  @media (min-width: 768px) {
    display: block;
  }
`;

export const CarLogoContainer = styled.div`
  display: flex;
  padding: 8px 2px 8px 2x;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  border-radius: 4px;
  border: 0.649px solid #E8E8E8;
  background: #FFF;
  margin-bottom: 8px;
`;

export const GaragesTitle = styled.div`
color: var(--Text-White, #FFF);
font-family: 'Euclid Circular B', 'Inter', sans-serif;
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 18px; /* 150% */
padding-bottom: 4px;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const GaragesStat = styled.div`
color: #B895FA;

/* Heading/X Small */
font-family: 'Euclid Circular B', 'Inter', sans-serif;
font-size: 18px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 133.333% */
padding-bottom: 4px;
  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const GaragesDescription = styled.div`
color: var(--Text-White, #FFF);

/* Paragraph/X Small */
font-family: 'Euclid Circular B', 'Inter', sans-serif;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 18px; /* 150% */
width:50%;
padding-bottom: 4px;
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const ViewGaragesClaimsWrapper = styled.div`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 20px 16px 0 16px;
  border-radius: 16px;
  min-width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--line-primary-n-200, #E7E7F0);
  background: var(--background-secondary-n-50, #F8F7FC);
`;

export const ViewGaragesContainer = styled.div`
  display: flex;
  gap: 16px;
  overflow: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding:0px 20px;
  @media (min-width: 768px) {
    padding:0px 32px;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ClaimIconWrapper = styled.div`
  margin-right: 8px;
`;

export const ClaimItemText = styled.div`
  color: var(--text-secondary-n-400, #5B5675);

/* Paragraph/X Small */
font-family: 'Euclid Circular B', 'Inter', sans-serif;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 18px; /* 150% */
`;

export const ClaimsSectionTitle = styled.div`
color: var(--Neutral-N500, #36354C);
font-family: 'Euclid Circular B', 'Inter', sans-serif;
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: 18px; /* 180% */
`;

export const ClaimsSectionSubtitle = styled.div`
color: var(--Purple-P400, #5920C5);

/* Heading/X Small */
font-family: 'Euclid Circular B', 'Inter', sans-serif;
font-size: 18px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 133.333% */
margin:4px 0px;
`;

export const ClaimsListContainer = styled.div`
  max-width:193px;
  /* Container for claim items list */
`;

export const OuterWrapper = styled.div`
  /* Outer wrapper container */
    background-image: url(${resolvePath("/images/backgroundknowyourcustomers.svg")});
    background-repeat: repeat-x;
    background-size: contain;
    padding: 24px 0px 24px 0px;
    @media (min-width: 768px) {
      padding: 32px 0px 32px 0px;
    }
`;

export const ClaimBannerText = styled.div`
color: var(--Neutral-N600, #040222);

/* Heading/X Small */
font-family: 'Euclid Circular B', 'Inter', sans-serif;
font-size: 18px;
font-style: normal;
font-weight: 600;
line-height: 4px; /* 133.333% */
`;

export const ClaimBannerSvg = styled.svg`
`;

export const ClaimBannerWrapper = styled.div`
  margin:0px 20px 8px 20px;
  @media (min-width: 768px) {
    margin: 0 32px 8px 32px;
  }
`;

export const RootContainer = styled.div`
  margin: 0 -20px;
    @media (min-width: 768px) {
    margin: 0 -32px;
  }
`;